import { Injectable, Optional, SkipSelf } from '@angular/core';

/**
 * Texts to render on the code editor.
 */
@Injectable()
export class CodeEditorIntl {
  copyLabel = 'å¤å¶';

  copiedLabel = 'å·²å¤å¶';

  readonlyLabel = 'åªè¯»';

  readwriteLabel = 'è¯»å';

  clearLabel = 'æ¸ç©º';

  recoverLabel = 'æ¢å¤';

  findLabel = 'æ¥æ¾';

  formatLabel = 'æ ¼å¼å';

  foldLabel = 'æå ';

  exportLabel = 'å¯¼åº';

  importLabel = 'å¯¼å¥';

  lightThemeLabel = 'æ¥é´';

  darkThemeLabel = 'å¤é´';

  showDiffLabel = 'æ¾ç¤ºæ´æ°';

  fullscreenLabel = 'å¨å±';

  exitFullscreenLabel = 'éåºå¨å±';

  // éå¯¹æä¸ªè¯­è¨ç¿»è¯æé¢åç¨æ·çæ ç­¾.
  // æ¯å¦: yaml -> YAML, jenkinsfile -> Jenkinsfile.
  getLanguageLabel(lang: string) {
    return ('' + lang).toUpperCase();
  }
}

export function CODE_EDITOR_INTL_PROVIDER_FACTORY(parentIntl: CodeEditorIntl) {
  return parentIntl || new CodeEditorIntl();
}

/** @docs-private */
export const CODE_EDITOR_INTL_INTL_PROVIDER = {
  // If there is already an CodeEditorIntl available, use that. Otherwise, provide a new one.
  provide: CodeEditorIntl,
  deps: [[new Optional(), new SkipSelf(), CodeEditorIntl]],
  useFactory: CODE_EDITOR_INTL_PROVIDER_FACTORY,
};
